// Root level icons

// Client icons
export { ChartIcon } from "./chart";
export { BarbellsIcon } from "./barbells";

// Trainer icons
export { TrainerIcon } from "./trainer";
export { DartIcon } from "./dart";
